import { render, staticRenderFns } from "./FreebiesEditPage.vue?vue&type=template&id=317ce9da"
import script from "./FreebiesEditPage.vue?vue&type=script&lang=js"
export * from "./FreebiesEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports